import { isEmpty } from "lodash";
import { Purchase, PurchaseStatus } from "types";
import { Options, useInfiniteCollection } from "../useInfiniteCollection";
import { useUser } from "@/hooks/useAccount";
import { useAffiliatePurchaseScope } from "@/hooks/useAffiliatePurchaseScope";

export const usePurchases = (queryParams: any = {}, options?: Options<Purchase>) => {
    const user = useUser();
    const { isAffiliateScopeReady, partnerFilter } = useAffiliatePurchaseScope(user);

    const params: any = {
        status: PurchaseStatus.COMMITTED, // We  never fetch non-committed purchases
        limit: 20,
        ...queryParams,
        ...partnerFilter,
    };

    const response = useInfiniteCollection<Purchase>("purchases", params, {
        keepPreviousData: isEmpty(queryParams),
        ...options,
        enabled: isAffiliateScopeReady && (options?.enabled ?? true),
    });
    return { ...response, purchases: response.data, isLoadingPurchases: response.isLoading };
};
